/* eslint-disable no-process-env */

// Default dev config. This requires a locally run `api-cp-lander`
let env = 'local';
let recaptchaSiteKey = process.env.RECPATCHA_SITE_KEY;
let apiHost = 'http://localhost:8080/';

// NODE_ENV is set to 'production' when the app is built using 'npm run build'
if (process.env.NODE_ENV === 'production') {
  // GASKET_ENV is set during runtime by the gasket app (see lifecyles/express.js)
  env = window.GASKET_ENV;

  // These captcha keys are public and are not sensitive
  recaptchaSiteKey = '6LfqsjsdAAAAAE0SmHzRnFBxiwOz30tes-RZlSHI'; // dev test
  if (env === 'prod') {
    recaptchaSiteKey = '6LdGk6wdAAAAANdMaRs7PhKe5zhhtDtuhUXqu7Cm'; // prod
  }

  // This points to the api proxy created by the gasket app
  apiHost = '/domain-parking/parking-api/';
}

export const Settings = {
  CASHPARKING_API_HOST: apiHost,
  CASHPARKING_API_PATH: `${apiHost}v1/domains`,
  RECPATCHA_SITE_KEY: recaptchaSiteKey,
  PUBLIC_URL: process.env.PUBLIC_URL
};

export const SystemDefault = {
  PRIVACY_POLICY_URL: 'https://www.godaddy.com/agreements/showdoc?pageid=PRIVACY'
};
